import React, { useRef, useEffect, useState, memo } from "react";
import { useTheme } from "@mui/material/styles";
import { Box, IconButton, ThemeProvider, createTheme } from "@mui/material";
import useSideScreen from "./Hooks/useSideScreen";
import { AppBar, Toolbar, SwipeableDrawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronRight from "@mui/icons-material/ChevronRight";
import useMediaQuery from "@mui/material/useMediaQuery";
import Text from "../genericComponents/Text";

const SideScreenDrawer = ({ primary, sideScreen, index }) => {
  const SideScreen = sideScreen ? sideScreen.component : null;
  const notifyParent =
    sideScreen && sideScreen.options && sideScreen.options.notifyParent
      ? sideScreen.options.notifyParent
      : () => {};
  const data =
    sideScreen && sideScreen.options && sideScreen.options.data
      ? sideScreen.options.data
      : null;
  const drawer = useRef(null);
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const forceXsTheme = createTheme({
    ...theme,
    isXs,
    breakpoints: {
      values: {
        xs: 0,
      },
    },
  });
  const paperStyle = {
    overflow: "hidden",
    position: "relative",
    marginLeft: -1,
    borderLeft: `1px solid ${theme.palette.primary.main}`,
    // horizontal scroll removed
    // whiteSpace: 'nowrap',
    height: "100%",
  };
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [header, setHeader] = useState();
  useEffect(() => {
    setTimeout(() => {
      if (!primary)
        if (isMobile) {
          drawer.current.style.width = "100%";
        } else {
          drawer.current.style.width = "320px";
        }
    }, 0); //put in end of queue.
  });
  const { closeSideScreen } = useSideScreen();

  let style = {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxShadow: theme.shadows[4],
    overflow: "hidden",
    width: 0,

    [theme.breakpoints.down("sm").replace("max-width", "maxWidth")]: {
      width: "100%",
    },
    height: "100vh",
    // borderLeft: `1px solid ${theme.palette.primary.main}`
  };
  const drawerIndex = index ? theme.zIndex.drawer + index : theme.zIndex.drawer;
  if (primary) {
    if (!sideScreen) {
      style = { ...style, width: 0, zIndex: drawerIndex };
    } else if (isMobile) {
      style = { ...style, width: "100%", zIndex: drawerIndex };
    } else {
      style = { ...style, width: "320px", zIndex: drawerIndex };
    }
  } else {
    style = {
      ...style,
      position: "absolute",
      top: 0,
      right: 0,
      width: 0,
      zIndex: drawerIndex,
    };
  }
  const Icon = header?.icon??<></>;
  return (
    <SwipeableDrawer
      disableSwipeToOpen={true}
      ref={drawer}
      onTransitionEnd={() => {
        if (drawer.current.style.width === "0px") {
          closeSideScreen();
        }
      }}
      style={style}
      anchor={"right"}
      open={true}
      onOpen={() => {}}
      onClose={() => (drawer.current.style.width = "0")}
      PaperProps={{
        style: paperStyle,
      }}
      variant="permanent"
    >
      <AppBar
        style={{
          color:"white",
          position: "absolute",
        }}
      >
        <Toolbar
          style={{
            paddingRight: 0,
          }}
        >
          {header?.icon?<Icon fontSize="large" />:null}
          <Text          
            text={header?.text}
            component="h1"
            variant="h6"
            noWrap
            style={{
              marginLeft:theme.spacing(1),
              flex: 1,
            }}
          />
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <IconButton
              onClick={() => (drawer.current.style.width = 0)}
              style={{ marginRight: theme.spacing(1) }}
            >
              <CloseIcon sx={{color:"white"}} fontSize="large" />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <IconButton
              onClick={() => (drawer.current.style.width = 0)}
              style={{ marginRight: theme.spacing(1) }}
            >
              <ChevronRight sx={{color:"white"}} fontSize="large"  />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <div
        style={{
          marginTop: `${theme.appBarHeight ? theme.appBarHeight : 64}px`,
          padding: theme.spacing(2),
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {sideScreen && (
          <ThemeProvider theme={forceXsTheme}>
            <SideScreen
              notifyParent={notifyParent}
              data={data}
              close={() => (drawer.current.style.width = 0)}
              setHeader={setHeader}
            />
          </ThemeProvider>
        )}
      </div>
    </SwipeableDrawer>
  );
};
export default memo(SideScreenDrawer);
